import * as React from "react";

;
export const StarLoyalty = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none" {...props}><path fill="#100722" d="m6 .5 1.622 3.767 4.084.379-3.081 2.707.902 4.001L6 9.26l-3.527 2.094.902-4.001L.294 4.646l4.084-.379L6 .5Z" /></svg>;